{
  "defaultCurrencyConfig": {
    "symbol": "$",
    "positionLeft": true
  },
  "wrapper": {
    "header": {
      "book-now": "Book Now. ",
      "pay": "Pay Over Time.",
      "powered-by": "Powered by "
    },
    "footer": {
      "uplift": {
        "email": "support@uplift.ca"
      },
      "flexpay": {
        "email": "customercare@upgrade.com"
      },
      "telephone": {
        "link": "+18442575400",
        "text": "(844) 257-5400",
        "full": "+1 (844) 257-5400"
      }
    },
    "agent-updated": {
      "message": "Your agent updated your trip's details and/or traveler information. Before continuing, please make sure the updated itinerary is correct.",
      "dismiss": "Dismiss"
    }
  },
  "document-view": {
    "buttons": {
      "close": {
        "label": "Close"
      },
      "print": {
        "label": "Print"
      }
    }
  },
  "time": {
    "months": {
      "1": "Jan",
      "2": "Feb",
      "3": "Mar",
      "4": "Apr",
      "5": "May",
      "6": "Jun",
      "7": "Jul",
      "8": "Aug",
      "9": "Sep",
      "10": "Oct",
      "11": "Nov",
      "12": "Dec"
    }
  },
  "regions": {
    "AB": "Alberta",
    "BC": "British Columbia",
    "MB": "Manitoba",
    "NB": "New Brunswick",
    "NL": "Newfoundland and Labrador",
    "NT": "Northwest Territories",
    "NS": "Nova Scotia",
    "NU": "Nunavut",
    "ON": "Ontario",
    "PE": "Prince Edward Island",
    "QC": "Quebec",
    "SK": "Saskatchewan",
    "YT": "Yukon Territory"
  },
  "processing": "Processing...",
  "mcodes": {
    "-100": "",
    "-1": "Oops, something unexpected has happened.",
    "0": "Invalid Application",
    "1": "Sorry, this itinerary does not qualify for Pay Monthly.",
    "2": "Sorry, this itinerary does not qualify for Pay Monthly.",
    "3": "Uh oh, an error occurred processing your request. Try again in a few minutes. If the problem persists, please contact Uplift's support line.",
    "4": "<div><span>Too many verification attempts using this mobile number.</span><br/><span>Please use another number, or try again after 24 hours.</span></div>",
    "5": "Incorrect Verification Code",
    "6": "The Social Security Number does not match.",
    "7": "There are difficulties in verifying your identity, and we are thus unable to process your loan request.",
    "8": "Sorry, the network request timed out. Please try again.",
    "9": "This mobile number is already associated with an account in USA/English",
    "10": "Unsupported region",
    "11": "Unsupported postal code",
    "12": "PO Box addresses are not supported. Please provide a full street address to continue.",
    "13": "Unsupported country",
    "14": "Your session has ended or your previous loan application approval has expired. Please re-apply. A new application will not affect your credit score.",
    "15": "The country associated with your application has changed. Please re-apply. A new application will not affect your credit score.",
    "16": "The language associated with your application has changed. Please re-apply. A new application will not affect your credit score.",
    "17": "The currency associated with your application has changed. Please re-apply. A new application will not affect your credit score.",
    "18": "Transaction declined. Please use a different payment method.",
    "19": "You have exceeded the application time limit. Please re-apply to continue. A new application will not affect your credit score.",
    "20": "<span>It looks like the person who applied for the loan is no longer traveling. Unfortunately, Uplift can only proceed with a loan request for <strong>someone listed on your itinerary</strong>.</span>",
    "50": "Uplift is currently experiencing technical difficulties. Please try again.",
    "51": "Transaction declined. Please use a different payment method.",
    "52": "Sorry, Uplift was unable to access the document you requested. Please try again.",
    "60": "Please make a selection to continue.",
    "bls-0": "Internal error. Please provide a new card number.",
    "bls-2": "This form of payment is not accepted. Please provide a new card number.",
    "bls-3": "American Express cards not accepted. Please provide a new card number.",
    "bls-4": "Card is not accepted. Please provide a new card number.",
    "bls-5": "Visa cards are not accepted. Please provide a new card number.",
    "bls-6": "This form of payment is not accepted. Please provide a new card number."
  },
  "documents": {
    "til": "Loan Agreement",
    "dcd": "Payment Terms Agreement",
    "cpa": "Credit Profile Authorization",
    "tos": "Terms of Use",
    "pp": "Privacy Policy",
    "esign": "E-Sign Consent",
    "icc": "Increased Cost of Credit / Adverse Action",
    "loanAgreement": "Loan Agreement",
    "paymentAgreement": "Payment Terms Agreement",
    "bapn": "Borrower Agreement & Promissory Note",
    "ach": "Pre-Authorized Debit Agreement",
    "drd": "Debt Ratio Disclosure"
  },
  "failedToLoad": "<span>{{documentName}} failed to load.</span>",
  "retry": "Retry?",
  "from": "from ",
  "cobrandedLoading": "<UpliftLogo /> is becoming <FlexpayLogo />",
  "flexpay": {
    "fullAddress": "410 Adelaide Street West<br>Suite 220<br>Toronto, ON M5V 1S8",
    "fullCompanyName": "Uplift Canada Services ULC",
    "payableCompanyName": "Uplift Canada Services ULC",
    "payableCompanyAddressName": "Flex Pay ℅ Uplift Canada Services ULC",
    "website": "upgrade.com/pay"
  },
  "uplift": {
    "fullAddress": "410 Adelaide Street West<br>Suite 220<br>Toronto, ON M5V 1S8",
    "fullCompanyName": "Uplift Canada Services ULC",
    "payableCompanyName": "Uplift, Inc.",
    "payableCompanyAddressName": "Uplift Canada Services ULC",
    "website": "pay.uplift.com"
  }
}
